import { v4 as uuidV4 } from 'uuid';

import { GraphChartType } from 'business/data-analysis/pages/graph/components/chart/types';
import { GraphState } from 'business/data-analysis/pages/graph/hooks/graph-context/types';
import { displayTypes } from 'business/data-analysis/pages/graph/types';
import { GraphSetTypeEnum_Enum } from 'generated/graphql';

export const createEmptyGraph = (
  graphNumber: number,
  mode: GraphSetTypeEnum_Enum,
): { id: string } & {
  newGraph: GraphState;
} => {
  return {
    id: uuidV4(),
    newGraph: {
      title: '',
      displayType: displayTypes.graph,
      chartType:
        mode === GraphSetTypeEnum_Enum.Period
          ? GraphChartType.LINE
          : GraphChartType.BAR,
      parameters: new Map(),
      graphNumber,
    },
  };
};
